import React from "react";
import "./styles.css";
import "./mobile.css";
import { ModalClose } from "bcms-react";
import CustomModal, { CustomModalFooter, ModalPrimaryButton } from 'components/custom-ui/CustomModal';

/**
 * @function ChatEndSessionModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the ChatEndSessionModal.
 */
export default function ChatEndSessionModal(props) {
  return (
    <CustomModal title="Please Confirm" id="ChatEndSessionModal" className="chat-end-session-modal">
      <CustomModalFooter>
        <ModalClose id="ChatEndSessionModal">
          <ModalPrimaryButton onClick={ props.data.onClick } text="End Session"/>
        </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}